import { IoIosClose, IoIosCheckmark } from "react-icons/io";

export default function PasswordRules({
  minchar,
  upcase,
  lowcase,
  number,
  special,
}) {
  const rules = [
    { label: "Minimum of 8 characters", valid: minchar },
    { label: "Include at least 1 upper case", valid: upcase },
    { label: "Include at least 1 lower case", valid: lowcase },
    { label: "At least 1 number", valid: number },
    { label: "At least 1 special character", valid: special },
  ];

  return (
    <div className="space-y-2">
      {rules.map((rule, i) => (
        <div key={i} className="flex items-center gap-2">
          {rule.valid ? (
            <IoIosCheckmark className="text-green-600 w-5 h-5" />
          ) : (
            <IoIosClose className="text-red-600 w-5 h-5" />
          )}
          <span
            className={`text-sm ${
              rule.valid ? "text-green-700" : "text-red-700"
            }`}
          >
            {rule.label}
          </span>
        </div>
      ))}
    </div>
  );
}
